import http from "./http";

export function getDashboard(params) {
  return http.get("/admin/dashboard", { params });
}
